// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__Mcd_E","checkboxCol":"Table_checkboxCol__3HayI","emailCol":"Table_emailCol__1sRah","actionCol":"Table_actionCol__VNYf8"};